import fetch from "./fetch";
/**
 * 医生管理
 */
const doctor = {
  //相关推荐枚举
  getDoctorList(params) {
    return fetch({
      isLoading: true,
      url: "/h5DmUser/page",
      method: "GET",
      params,
    });
  },
  //根据医生id获取医生白名单详情
  getDoctorWhitelistDataById(params) {
    return fetch({
      isLoading: true,
      url: `/h5DmUser/${params.id}`,
      method: "GET",
      params: {},
    });
  },
  //修改医生数据
  updateDoctorlist(data) {
    return fetch({
      isLoading: true,
      url: "/h5DmUser/update",
      method: "POST",
      data,
    });
  },
  //修改医生数据
  updateDoctorPassword(data) {
    return fetch({
      isLoading: true,
      url: "/h5DmUser/updatePassword",
      method: "POST",
      data,
    });
  },
  //上传资质
  uploadQualification(data) {
    return fetch({
      isLoading: true,
      url: "/h5DmUser/update",
      method: "POST",
      data,
    });
  },
  //导出医生海报
  exportDoctorPoster(params) {
    return fetch({
      isLoading: true,
      url: "/h5DmUser/exportPoster",
      method: "GET",
      params,
    });
  },
};

export default doctor;
